<template>
  <BModal :model-value="modal" scrollable centered title="Guest" @update:modelValue="updateModal" > 
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="">Guest</h5>
        
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <BRow>
        <BCol md="4">
          <div class="form-group">
            <BFormSelect v-model="selectTitle" :options="titles" class="form-select">
              <template #first>
                <BFormSelectOption :value="null" disabled>Select title</BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          
        </BCol>
        <BCol md="8">
          <div class="form-group">
            <BFormInput type="text" placeholder="Name">
              
            </BFormInput>
          </div>
        </BCol>
      </BRow>
      <div class="form-group">
        <BFormInput type="text" placeholder="ID/Passport">
  
        </BFormInput>
      </div>
      <div class="form-group">
        <BFormInput type="text" placeholder="No Contact">
        </BFormInput>
      </div>
      <BRow>
        <BCol>
          <div class="form-group">
            <BFormInput type="text" placeholder="Nationality">
            </BFormInput>
          </div>
        </BCol>
        <BCol>
          <div class="form-group">
            <BFormInput type="text" placeholder="City">
            </BFormInput>
          </div>
        </BCol>
      </BRow>
      <div class="form-group">
        <label for="">Identity Photo</label>
        <BFormInput type="file">
        </BFormInput>
        <BFormText id="input-live-help">max.500 KB</BFormText>
      </div>
      <div class="form-group">
        <BFormTextarea v-model="textEx" placeholder="Address" rows="3" />
      </div>
    </BForm>
    <template #footer>
        <div class="d-flex justify-content-end">
            <BButton variant="primary" @click="submitReservation" class="mr-2">Save</BButton>
            <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
        </div>
    </template>
  </BModal>
</template>

<script>
import { 
    BModal,
    BRow,
    BCol,
    BForm,
    BFormText,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BFormInput,
    BFormTextarea, 
} from "bootstrap-vue-next";

import { ref } from 'vue';

export default {
    components: {
        BModal,
        BRow,
        BCol,
        BForm,
        BFormText,
        BFormSelect,
        BFormSelectOption,
        BButton,
        BFormInput,
        BFormTextarea
    },
    props: {
        modal: Boolean,
    },
    emits: ["update:modal"],

    setup(props, {emit}){
        console.log(props)
        const titles = ref([
          {text: 'Mr', value: 'mr'},
          {text: 'Ms', value: 'ms'},
          {text: 'Mrs', value: 'mrs'}
        ])
        const selectTitle = ref(null)

        const updateModal = (value) => {
                emit("update:modal", value); // Sync modal state with parent
            };
        return{
            updateModal,
            selectTitle,
            titles
        }
    }

}
</script>

<style>

</style>